import { useLanguageStore, Language } from '../stores/language';

interface LanguageToggleProps {
  hasChineseContent: boolean;
}

export function LanguageToggle({ hasChineseContent }: LanguageToggleProps) {
  const { language, setLanguage } = useLanguageStore();

  // Don't render if no Chinese content available
  if (!hasChineseContent) {
    return null;
  }

  const toggleLanguage = (lang: Language) => {
    setLanguage(lang);
  };

  return (
    <div className="flex flex-row items-center gap-1 bg-gray-100 dark:bg-gray-800 rounded-lg p-1 flex-shrink-0">
      <button
        onClick={() => toggleLanguage('en')}
        className={`px-2.5 py-1 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
          language === 'en'
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm'
            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
        }`}
      >
        EN
      </button>
      <button
        onClick={() => toggleLanguage('zh')}
        className={`px-2.5 py-1 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
          language === 'zh'
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm'
            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
        }`}
      >
        中文
      </button>
    </div>
  );
}
